/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_TitleInputs */



/**
* | output |
* | --- |
* | "VEKN" |
*
* @param {Vekn_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_title = /** @type {((inputs?: Vekn_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("VEKN")
	return /** @type {LocalizedString} */ ("VEKN")
});